// lucide-react → @tabler/icons-react shim.
//
// The ArcDisk components were written against lucide-react. Mosaico already
// ships @tabler/icons-react and must not gain a second icon library, so the
// copied components import their icons from here under the lucide names.
// Both libraries render a 24px stroked SVG and honour `className`; the copied
// code sizes icons through Tailwind `size-*` classes, which override the
// width/height attributes either library emits.
import {
  IconCheck,
  IconChevronDown,
  IconDisc,
  IconExternalLink,
  IconFileText,
  IconFilter,
  IconHelpCircle,
  IconInbox,
  IconInfoCircle,
  IconMovie,
  IconPhoto,
  IconPhotoOff,
  IconQuote,
  IconSearch,
  IconTrendingDown,
  IconTrendingUp,
  IconX,
} from '@tabler/icons-react'

export {
  IconCheck as Check,
  IconChevronDown as ChevronDown,
  IconDisc as Disc3,
  IconExternalLink as ExternalLink,
  IconFileText as FileText,
  IconMovie as Film,
  IconFilter as Filter,
  IconHelpCircle as HelpCircle,
  IconPhoto as Image,
  IconPhotoOff as ImageOff,
  IconInbox as Inbox,
  IconInfoCircle as Info,
  IconQuote as Quote,
  IconSearch as Search,
  IconTrendingDown as TrendingDown,
  IconTrendingUp as TrendingUp,
  IconX as X,
}
